"use client";
import { Stack, Table, Box } from "@chakra-ui/react";
import { Balancer } from "react-wrap-balancer";
import { useHeadingVariant, useTextVariant } from "@/theme/hooks/useSectionStyle";
import { Heading, Text } from "@/elements";
import { TABLE_DATA } from "./constants";

const FeaturesComparsion = () => {
  const { heading, desc, headers, data } = TABLE_DATA;
  const HeadingVariant = useHeadingVariant();
  const TextVariant = useTextVariant();

  return (
    <Stack gap={8}>
      {heading && (
        <Balancer>
          <Heading as="h2" variant={HeadingVariant} textAlign={"center"}>
            {heading}
          </Heading>
        </Balancer>
      )}
      {desc && (
        <Balancer>
          <Text variant={TextVariant} color="text.100" textAlign={"center"}>
            {desc}
          </Text>
        </Balancer>
      )}

      <Table.Root
        striped
        display={{ base: "none", md: "block" }}
        boxShadow={"xl"}
        borderColor={"rgb(237,242,247)"}
        borderWidth={"2px"}
      >
        <Table.Header>
          <Table.Row>
            <Table.ColumnHeader
              color="black"
              fontSize="24px"
              py={6}
              textTransform={"none"}
            >
              {headers.capability}
            </Table.ColumnHeader>
            <Table.ColumnHeader
              backgroundColor={"#3182ce"}
              color="white"
              fontSize="24px"
              py={6}
              textTransform={"none"}
              border="0px"
              className="brand-shadow"
            >
              {headers.onemind}
            </Table.ColumnHeader>
            <Table.ColumnHeader
              color="black"
              fontSize="24px"
              py={6}
              textTransform={"none"}
            >
              {headers.traditional}
            </Table.ColumnHeader>
            <Table.ColumnHeader
              color="black"
              fontSize="24px"
              py={6}
              textTransform={"none"}
            >
              {headers.singleVendor}
            </Table.ColumnHeader>
            <Table.ColumnHeader
              color="black"
              fontSize="24px"
              py={6}
              textTransform={"none"}
            >
              {headers.diyMultiCloud}
            </Table.ColumnHeader>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {data.map((item, index) => (
            <Table.Row key={index} style={{ backgroundColor: "transparent" }}>
              <Table.Cell fontWeight="bold">{item.capability}</Table.Cell>
              <Table.Cell
                whiteSpace="normal"
                backgroundColor="#3182ce"
                color="white"
                fontSize="18px"
                fontWeight="semibold"
                zIndex={1}
                border="1px solid rgba(255, 255, 255, 0.3)"
              >
                {item.onemind}
              </Table.Cell>
              <Table.Cell whiteSpace="normal">{item.traditional}</Table.Cell>
              <Table.Cell whiteSpace="normal">{item.singleVendor}</Table.Cell>
              <Table.Cell whiteSpace="normal">{item.diyMultiCloud}</Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table.Root>

      <Stack display={{ base: "flex", md: "none" }} gap={4}>
        {data.map((item, index) => (
          <Box key={index} p={4} borderWidth="1px" borderRadius="md" boxShadow="md">
            <Text fontSize="lg" fontWeight="bold" mb={2}>
              {item.capability}
            </Text>
            <Stack gap={3}>
              <Box>
                <Text fontSize="md" fontWeight="bold" color="gray.500">
                  {headers.onemind}
                </Text>
                <Text
                  variant={TextVariant}
                  mt={1}
                  p={2}
                  bg="#3182ce"
                  color="white"
                  borderRadius="md"
                >
                  {item.onemind}
                </Text>
              </Box>
              <Box>
                <Text fontSize="md" fontWeight="bold" color="gray.500">
                  {headers.traditional}
                </Text>
                <Text variant={TextVariant} mt={1} p={2} bg="gray.100" borderRadius="md">
                  {item.traditional}
                </Text>
              </Box>
              <Box>
                <Text fontSize="md" fontWeight="bold" color="gray.500">
                  {headers.singleVendor}
                </Text>
                <Text variant={TextVariant} mt={1} p={2} bg="gray.100" borderRadius="md">
                  {item.singleVendor}
                </Text>
              </Box>
              <Box>
                <Text fontSize="md" fontWeight="bold" color="gray.500">
                  {headers.diyMultiCloud}
                </Text>
                <Text variant={TextVariant} mt={1} p={2} bg="gray.100" borderRadius="md">
                  {item.diyMultiCloud}
                </Text>
              </Box>
            </Stack>
          </Box>
        ))}
      </Stack>
    </Stack>
  );
};

export default FeaturesComparsion;
